export interface ComicItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  rating: number;
  views: number;
  description: string;
  status: '连载中' | '已完结';
  updateTime: string;
  latestChapter: string;
  totalChapters: number;
  tags: string[];
}

export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
  count: number;
  description: string;
}

export const categories: CategoryItem[] = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 1280, description: '甜蜜浪漫的韩国恋爱漫画，讲述心动故事' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 960, description: '充满想象力的奇幻世界冒险漫画' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 850, description: '热血激燃的动作格斗韩国漫画' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', count: 620, description: '扣人心弦的悬疑推理漫画' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 750, description: '轻松欢乐的搞笑日常漫画' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 890, description: '深刻动人的剧情向韩国漫画' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', count: 340, description: '惊悚刺激的恐怖漫画' },
  { slug: 'school', name: '校园', icon: 'ri-building-line', count: 560, description: '青春活力的校园题材漫画' },
  { slug: 'workplace', name: '职场', icon: 'ri-briefcase-line', count: 430, description: '职场奋斗与成长的韩国漫画' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line', count: 380, description: '古色古香的历史题材漫画' },
  { slug: 'sports', name: '运动', icon: 'ri-basketball-line', count: 290, description: '热血运动竞技韩国漫画' },
  { slug: 'reincarnation', name: '转生', icon: 'ri-loop-left-line', count: 520, description: '重生转世异世界题材漫画' },
];

export const featuredComics: ComicItem[] = [
  {
    id: 'comic-001',
    title: '恶魔的契约',
    author: '金智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20fantasy%2C%20dark%20haired%20female%20lead%20in%20elegant%20dress%2C%20dramatic%20lighting%2C%20gothic%20atmosphere%2C%20soft%20warm%20tones%2C%20clean%20background%2C%20professional%20illustration%2C%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-001&orientation=portrait',
    category: 'romance',
    rating: 9.6,
    views: 1280000,
    description: '为了拯救即将破产的家族，她与恶魔签订了危险的契约。然而，她不知道的是，这场交易将彻底改变她的人生轨迹。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第128话',
    totalChapters: 128,
    tags: ['恋爱', '奇幻', '契约', '豪门'],
  },
  {
    id: 'comic-002',
    title: '剑神重生',
    author: '朴俊秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20action%20martial%20arts%2C%20male%20swordsman%20with%20flowing%20robes%2C%20dramatic%20pose%20with%20sword%2C%20ancient%20Chinese%20inspired%20setting%2C%20warm%20golden%20tones%2C%20clean%20composition%2C%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-002&orientation=portrait',
    category: 'action',
    rating: 9.4,
    views: 2150000,
    description: '一代剑神陨落之后，意外重生回到少年时代。带着前世的记忆与剑术，他将重新踏上巅峰之路。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第215话',
    totalChapters: 215,
    tags: ['动作', '重生', '武侠', '修仙'],
  },
  {
    id: 'comic-003',
    title: '秘密花园',
    author: '李秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20sweet%20romance%2C%20couple%20in%20flower%20garden%2C%20soft%20pastel%20color%20palette%2C%20spring%20cherry%20blossom%20background%2C%20gentle%20atmosphere%2C%20clean%20composition%2C%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-003&orientation=portrait',
    category: 'romance',
    rating: 9.7,
    views: 1890000,
    description: '搬进新家后，她发现隔壁住着高中时代暗恋过的学长。这座秘密花园里，埋藏着多少未说出口的心意？',
    status: '已完结',
    updateTime: '2026-07-20',
    latestChapter: '全156话',
    totalChapters: 156,
    tags: ['恋爱', '校园', '治愈', '青春'],
  },
  {
    id: 'comic-004',
    title: '暗夜追踪者',
    author: '崔敏浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20noir%20detective%20thriller%2C%20male%20detective%20in%20trench%20coat%2C%20dark%20rainy%20city%20street%2C%20neon%20signs%2C%20moody%20lighting%2C%20suspenseful%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-004&orientation=portrait',
    category: 'suspense',
    rating: 9.3,
    views: 1560000,
    description: '一系列离奇的失踪案件背后，隐藏着一个惊人的真相。私家侦探韩在宇深入调查，却发现自己正被一双无形的眼睛注视着。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第98话',
    totalChapters: 98,
    tags: ['悬疑', '推理', '都市', '犯罪'],
  },
  {
    id: 'comic-005',
    title: '异世界餐厅',
    author: '姜美莱',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20fantasy%20food%20theme%2C%20cute%20female%20chef%20in%20magical%20kitchen%2C%20floating%20ingredients%2C%20warm%20cozy%20atmosphere%2C%20whimsical%20fantasy%2C%20soft%20warm%20colors%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-005&orientation=portrait',
    category: 'fantasy',
    rating: 9.5,
    views: 980000,
    description: '意外穿越到异世界的她，唯一擅长的就是做饭。开一家小餐厅，用美食治愈异世界的居民们吧！',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第167话',
    totalChapters: 167,
    tags: ['奇幻', '美食', '治愈', '异世界'],
  },
];

export const latestUpdates: ComicItem[] = [
  {
    id: 'comic-006',
    title: '重生之商道至尊',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20business%20office%20theme%2C%20confident%20male%20lead%20in%20suit%2C%20modern%20city%20skyline%20background%2C%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-006&orientation=portrait',
    category: 'workplace',
    rating: 9.2,
    views: 750000,
    description: '商界传奇重生回到创业初期，这次他要打造一个前所未有的商业帝国。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第89话',
    totalChapters: 89,
    tags: ['职场', '重生', '商战', '都市'],
  },
  {
    id: 'comic-007',
    title: '校草的心跳告白',
    author: '尹素恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20youth%20school%20romance%2C%20handsome%20male%20student%20and%20shy%20female%20student%2C%20school%20campus%20cherry%20blossom%2C%20bright%20spring%20colors%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-007&orientation=portrait',
    category: 'school',
    rating: 9.1,
    views: 820000,
    description: '转学到新学校的她，第一天就被校草盯上了。等等，他看她的眼神怎么不太对劲？',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第73话',
    totalChapters: 73,
    tags: ['校园', '恋爱', '青春', '甜宠'],
  },
  {
    id: 'comic-008',
    title: '恶灵猎人',
    author: '安在赫',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20supernatural%20horror%2C%20ghost%20hunter%20with%20spiritual%20weapon%2C%20dark%20haunted%20mansion%2C%20eerie%20moody%20atmosphere%2C%20cool%20dark%20tones%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-008&orientation=portrait',
    category: 'horror',
    rating: 9.0,
    views: 680000,
    description: '拥有看见鬼魂能力的少年，加入了一个神秘组织。他们要猎杀的，是危害人间的恶灵。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第56话',
    totalChapters: 56,
    tags: ['恐怖', '灵异', '动作', '少年'],
  },
  {
    id: 'comic-009',
    title: '后宫生存法则',
    author: '韩智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20historical%20palace%20drama%2C%20beautiful%20female%20lead%20in%20traditional%20hanbok%2C%20ancient%20Korean%20palace%20setting%2C%20elegant%20warm%20tones%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-009&orientation=portrait',
    category: 'historical',
    rating: 9.4,
    views: 920000,
    description: '穿越到古代朝鲜后宫的她，本以为能享受荣华富贵。殊不知，后宫的每一步都是生死博弈。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第142话',
    totalChapters: 142,
    tags: ['古风', '宫斗', '穿越', '权谋'],
  },
  {
    id: 'comic-010',
    title: '篮球之神',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20sports%20basketball%2C%20athletic%20male%20lead%20dribbling%20basketball%2C%20indoor%20court%20dynamic%20action%2C%20energetic%20warm%20lighting%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-010&orientation=portrait',
    category: 'sports',
    rating: 9.3,
    views: 610000,
    description: '身高只有170cm的少年，却拥有惊人的篮球天赋。他要证明，篮球不只是高个子的运动。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第104话',
    totalChapters: 104,
    tags: ['运动', '篮球', '热血', '竞技'],
  },
  {
    id: 'comic-011',
    title: '反派千金的逆袭',
    author: '朴秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20villainess%20reincarnation%2C%20elegant%20female%20noble%20in%20fancy%20dress%2C%20European%20palace%20ballroom%2C%20dramatic%20lighting%2C%20warm%20golden%20tones%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-011&orientation=portrait',
    category: 'reincarnation',
    rating: 9.6,
    views: 1350000,
    description: '穿成小说里的恶毒女配，她决定改写命运。这一次，她要做自己人生的主角。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第198话',
    totalChapters: 198,
    tags: ['转生', '恋爱', '宫廷', '逆袭'],
  },
  {
    id: 'comic-012',
    title: '笑傲江湖之日常',
    author: '李泰民',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20comedy%20slice%20of%20life%2C%20funny%20expressions%20exaggerated%2C%20colorful%20playful%20background%2C%20bright%20cheerful%20colors%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-012&orientation=portrait',
    category: 'comedy',
    rating: 9.0,
    views: 580000,
    description: '武林高手们的搞笑日常！剑圣今天也在为外卖送不到山顶而烦恼。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第166话',
    totalChapters: 166,
    tags: ['搞笑', '武侠', '日常', '轻松'],
  },
  {
    id: 'comic-013',
    title: '眼泪的重量',
    author: '宋智孝',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20emotional%20drama%2C%20woman%20looking%20sad%20by%20window%2C%20rainy%20day%2C%20melancholic%20warm%20tones%2C%20soft%20lighting%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-013&orientation=portrait',
    category: 'drama',
    rating: 9.5,
    views: 1100000,
    description: '一个关于失去、成长与重新开始的故事。当眼泪流尽，剩下的就是坚强。',
    status: '已完结',
    updateTime: '2026-06-15',
    latestChapter: '全98话',
    totalChapters: 98,
    tags: ['剧情', '治愈', '成长', '现实'],
  },
];

export const popularRanking: ComicItem[] = [
  {
    id: 'comic-003',
    title: '秘密花园',
    author: '李秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20sweet%20romance%2C%20couple%20in%20flower%20garden%2C%20soft%20pastel%20color%20palette%2C%20spring%20cherry%20blossom%20background%2C%20gentle%20atmosphere%2C%20clean%20composition%2C%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-003&orientation=portrait',
    category: 'romance',
    rating: 9.7,
    views: 1890000,
    description: '搬进新家后，她发现隔壁住着高中时代暗恋过的学长。',
    status: '已完结',
    updateTime: '2026-07-20',
    latestChapter: '全156话',
    totalChapters: 156,
    tags: ['恋爱', '校园', '治愈', '青春'],
  },
  {
    id: 'comic-001',
    title: '恶魔的契约',
    author: '金智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20fantasy%2C%20dark%20haired%20female%20lead%20in%20elegant%20dress%2C%20dramatic%20lighting%2C%20gothic%20atmosphere%2C%20soft%20warm%20tones%2C%20clean%20background%2C%20professional%20illustration%2C%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-001&orientation=portrait',
    category: 'romance',
    rating: 9.6,
    views: 1280000,
    description: '为了拯救即将破产的家族，她与恶魔签订了危险的契约。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第128话',
    totalChapters: 128,
    tags: ['恋爱', '奇幻', '契约', '豪门'],
  },
  {
    id: 'comic-011',
    title: '反派千金的逆袭',
    author: '朴秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20villainess%20reincarnation%2C%20elegant%20female%20noble%20in%20fancy%20dress%2C%20European%20palace%20ballroom%2C%20dramatic%20lighting%2C%20warm%20golden%20tones%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-011&orientation=portrait',
    category: 'reincarnation',
    rating: 9.6,
    views: 1350000,
    description: '穿成小说里的恶毒女配，她决定改写命运。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第198话',
    totalChapters: 198,
    tags: ['转生', '恋爱', '宫廷', '逆袭'],
  },
  {
    id: 'comic-002',
    title: '剑神重生',
    author: '朴俊秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20action%20martial%20arts%2C%20male%20swordsman%20with%20flowing%20robes%2C%20dramatic%20pose%20with%20sword%2C%20ancient%20Chinese%20inspired%20setting%2C%20warm%20golden%20tones%2C%20clean%20composition%2C%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-002&orientation=portrait',
    category: 'action',
    rating: 9.4,
    views: 2150000,
    description: '一代剑神陨落之后，意外重生回到少年时代。',
    status: '连载中',
    updateTime: '2026-08-04',
    latestChapter: '第215话',
    totalChapters: 215,
    tags: ['动作', '重生', '武侠', '修仙'],
  },
  {
    id: 'comic-005',
    title: '异世界餐厅',
    author: '姜美莱',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20fantasy%20food%20theme%2C%20cute%20female%20chef%20in%20magical%20kitchen%2C%20floating%20ingredients%2C%20warm%20cozy%20atmosphere%2C%20whimsical%20fantasy%2C%20soft%20warm%20colors%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-005&orientation=portrait',
    category: 'fantasy',
    rating: 9.5,
    views: 980000,
    description: '意外穿越到异世界的她，唯一擅长的就是做饭。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第167话',
    totalChapters: 167,
    tags: ['奇幻', '美食', '治愈', '异世界'],
  },
  {
    id: 'comic-013',
    title: '眼泪的重量',
    author: '宋智孝',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20emotional%20drama%2C%20woman%20looking%20sad%20by%20window%2C%20rainy%20day%2C%20melancholic%20warm%20tones%2C%20soft%20lighting%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-013&orientation=portrait',
    category: 'drama',
    rating: 9.5,
    views: 1100000,
    description: '一个关于失去、成长与重新开始的故事。',
    status: '已完结',
    updateTime: '2026-06-15',
    latestChapter: '全98话',
    totalChapters: 98,
    tags: ['剧情', '治愈', '成长', '现实'],
  },
  {
    id: 'comic-009',
    title: '后宫生存法则',
    author: '韩智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20historical%20palace%20drama%2C%20beautiful%20female%20lead%20in%20traditional%20hanbok%2C%20ancient%20Korean%20palace%20setting%2C%20elegant%20warm%20tones%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-009&orientation=portrait',
    category: 'historical',
    rating: 9.4,
    views: 920000,
    description: '穿越到古代朝鲜后宫的她，本以为能享受荣华富贵。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第142话',
    totalChapters: 142,
    tags: ['古风', '宫斗', '穿越', '权谋'],
  },
  {
    id: 'comic-004',
    title: '暗夜追踪者',
    author: '崔敏浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20noir%20detective%20thriller%2C%20male%20detective%20in%20trench%20coat%2C%20dark%20rainy%20city%20street%2C%20neon%20signs%2C%20moody%20lighting%2C%20suspenseful%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=manhwa-cover-004&orientation=portrait',
    category: 'suspense',
    rating: 9.3,
    views: 1560000,
    description: '一系列离奇的失踪案件背后，隐藏着一个惊人的真相。',
    status: '连载中',
    updateTime: '2026-08-03',
    latestChapter: '第98话',
    totalChapters: 98,
    tags: ['悬疑', '推理', '都市', '犯罪'],
  },
];